import { useFliptFeature, type FliptFeature } from "~/hooks/useFliptFeature";
import { FLIPT_ROUTE_KEYS } from "~/router/constants";

/**
 * Flipt `nova-project-costs`, gating the Nova project Costs page — its sidebar
 * entry and its route. On for manifold stage only while the dashboard is rolled
 * out; project ownership remains the access gate underneath.
 */
export const useProjectCostsFeature = (): FliptFeature =>
  useFliptFeature(FLIPT_ROUTE_KEYS.NOVA_PROJECT_COSTS);
